import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
	name: "filterInvisibleAudioChannels",
	standalone: false,
})
export class FilterInvisibleAudioChannelsPipe implements PipeTransform {
	transform<T extends {visibleInGUI: boolean}>(items: T[]): T[] {
		if (!items) {
			return items;
		}

		return items.filter((item) => item.visibleInGUI);
	}
}
